/**
 * Mapeamento de ícones Material-UI para categorias de cores
 * Usado para integração do ColoredIcon com o menu principal
 */

import { IconCategory } from './iconColors';

export interface IconMapping {
  [key: string]: {
    category: IconCategory;
    ariaLabel?: string;
  };
}

/**
 * Mapeamento de ícones do menu para categorias
 * Cada ícone é mapeado para uma categoria que determina sua cor
 */
export const iconMapping: IconMapping = {
  // Dashboard e Relatórios
  'DashboardOutlined': { category: 'dashboard', ariaLabel: 'Dashboard' },
  'Dashboard': { category: 'dashboard', ariaLabel: 'Dashboard' },
  'Description': { category: 'reports', ariaLabel: 'Relatórios' },
  'Assessment': { category: 'reports', ariaLabel: 'Análise' },
  'Phone': { category: 'reports', ariaLabel: 'Chamadas' },
  'GridOn': { category: 'dashboard', ariaLabel: 'Momentos' },
  'ViewKanban': { category: 'dashboard', ariaLabel: 'Kanban' },
  'AccountBalanceWallet': { category: 'reports', ariaLabel: 'Carteiras' },

  // Tickets e Mensagens
  'WhatsApp': { category: 'tickets', ariaLabel: 'Tickets' },
  'FlashOn': { category: 'tickets', ariaLabel: 'Mensagens Rápidas' },
  'Forum': { category: 'tickets', ariaLabel: 'Chats' },
  'EventAvailable': { category: 'tickets', ariaLabel: 'Eventos' },

  // Contatos
  'ContactPhoneOutlined': { category: 'contacts', ariaLabel: 'Contatos' },
  'People': { category: 'contacts', ariaLabel: 'Pessoas' },
  'PeopleAltOutlined': { category: 'contacts', ariaLabel: 'Usuários' },

  // Configurações
  'SettingsOutlined': { category: 'settings', ariaLabel: 'Configurações' },
  'Settings': { category: 'settings', ariaLabel: 'Configurações' },
  'AccountTreeOutlined': { category: 'settings', ariaLabel: 'Filas' },
  'Cake': { category: 'settings', ariaLabel: 'Aniversários' },
  'Business': { category: 'settings', ariaLabel: 'Empresas' },
  'SwapHoriz': { category: 'settings', ariaLabel: 'Trocar Conta' },

  // Integrações
  'SyncAlt': { category: 'integrations', ariaLabel: 'Conexões' },
  'PhonelinkSetup': { category: 'integrations', ariaLabel: 'Configuração de Telefone' },
  'DeviceHubOutlined': { category: 'integrations', ariaLabel: 'Integração de Fila' },
  'Webhook': { category: 'integrations', ariaLabel: 'Webhook' },
  'ShapeLine': { category: 'integrations', ariaLabel: 'Fluxos' },
  'Campaign': { category: 'integrations', ariaLabel: 'Campanhas' },

  // Suporte e Ajuda
  'HelpOutline': { category: 'support', ariaLabel: 'Ajuda' },
  'Announcement': { category: 'support', ariaLabel: 'Anúncios' },
  'CodeRounded': { category: 'support', ariaLabel: 'API de Mensagens' },
  'AttachFile': { category: 'support', ariaLabel: 'Arquivos' },
  'AllInclusive': { category: 'support', ariaLabel: 'Prompts' },
  'LocalOffer': { category: 'support', ariaLabel: 'Tags' },
  'Schedule': { category: 'support', ariaLabel: 'Agendamentos' },
  'HistoryToggleOff': { category: 'support', ariaLabel: 'Histórico' },
  'MonitorHeart': { category: 'support', ariaLabel: 'Status' },

  // Financeiro
  'LocalAtm': { category: 'reports', ariaLabel: 'Financeiro' },

  // Expandir/Colapsar
  'ExpandLess': { category: 'dashboard', ariaLabel: 'Recolher' },
  'ExpandMore': { category: 'dashboard', ariaLabel: 'Expandir' },
};

/**
 * Obter categoria de um ícone pelo nome
 * @param iconName - Nome do ícone Material-UI
 * @returns Categoria do ícone ou 'dashboard' como padrão
 */
export function getIconCategory(iconName: string): IconCategory {
  const mapping = iconMapping[iconName];
  return mapping?.category || 'dashboard';
}

/**
 * Obter aria-label de um ícone pelo nome
 * @param iconName - Nome do ícone Material-UI
 * @returns Aria-label do ícone ou undefined
 */
export function getIconAriaLabel(iconName: string): string | undefined {
  const mapping = iconMapping[iconName];
  return mapping?.ariaLabel;
}
